// IndexedDB ラッパ — スコープ確定書 §8.1 のスキーマに準拠。
//
// 現状は最小実装: 全データ (AppState) を 1 レコードとして meta ストアに保存する単純戦略。
// 将来的にデータ量が増えたら roulettes / sets を分離する余地を残す（meta.schemaVersion で移行）。

import { openDB, type IDBPDatabase } from 'idb';
import type { AppState } from './types';
import { SCHEMA_VERSION } from './types';

// DB 名はビルド時に vite define で注入 (dev/公開リポジトリで分離するため)
const DB_NAME = __APP_DB_NAME__;
const DB_VERSION = 1;

const STORE_META = 'meta';
const STATE_KEY = 'state';

interface RRouletteSchema {
  meta: {
    key: string;
    value: AppState;
  };
}

let dbPromise: Promise<IDBPDatabase<RRouletteSchema>> | null = null;

function getDb(): Promise<IDBPDatabase<RRouletteSchema>> {
  if (!dbPromise) {
    dbPromise = openDB<RRouletteSchema>(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_META)) {
          db.createObjectStore(STORE_META);
        }
      }
    });
  }
  return dbPromise;
}

export async function loadState(): Promise<AppState | null> {
  const db = await getDb();
  const value = await db.get(STORE_META, STATE_KEY);
  if (!value) return null;
  return migrate(value);
}

export async function saveState(state: AppState): Promise<void> {
  const db = await getDb();
  await db.put(STORE_META, state, STATE_KEY);
}

export async function clearState(): Promise<void> {
  const db = await getDb();
  await db.delete(STORE_META, STATE_KEY);
}

// ─────────────────────────────────────────────────────────
//  スキーマ移行
// ─────────────────────────────────────────────────────────

function migrate(state: AppState): AppState {
  // 現在は v1 のみ。将来バージョンで if (state.schemaVersion < 2) { ... } を追加する。
  if (state.schemaVersion !== SCHEMA_VERSION) {
    state.schemaVersion = SCHEMA_VERSION;
  }
  return state;
}
